if (!customElements.get('brand-hub')) {
  class BrandHub extends HTMLElement {
    connectedCallback() {
      this.sets = Array.from(this.querySelectorAll('[data-brand-set]'));
      this.logos = Array.from(this.querySelectorAll('[data-brand-logo]'));
      this.current = 0;
      this.timer = null;
      this.autoplayEnabled = this.dataset.autoplay !== 'false';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 8) * 1000;
      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.count = Math.max(this.sets.length, this.logos.length);
      this.initCatalogNav();

      if (this.count <= 1) {
        this.show(0, false);
        return;
      }

      this.logos.forEach((logo) => {
        logo.addEventListener('click', () => {
          const index = parseInt(logo.dataset.blockIndex, 10);
          if (!Number.isNaN(index)) this.goTo(index, true);
        });
      });

      if (this.pauseOnHover && !this.reducedMotion) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const target = event.target.closest('[data-block-index]');
          if (!target || !this.contains(target)) return;
          const index = parseInt(target.dataset.blockIndex, 10);
          if (!Number.isNaN(index)) {
            this.stopAutoplay();
            this.goTo(index, false);
          }
        });
      }

      this.show(0, false);
      if (this.autoplayEnabled && !this.reducedMotion) this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    goTo(index, resetTimer) {
      if (this.count === 0) return;

      const next = ((index % this.count) + this.count) % this.count;
      if (next === this.current && resetTimer) {
        this.restartProgress();
        return;
      }

      this.current = next;
      this.show(next, resetTimer);
      if (resetTimer && this.autoplayEnabled && !this.reducedMotion) this.startAutoplay();
    }

    show(index, animateProgress) {
      this.sets.forEach((set, i) => {
        const isActive = i === index;
        set.classList.toggle('is-active', isActive);
        set.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.logos.forEach((logo, i) => {
        logo.classList.toggle('is-active', i === index);
        logo.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      this.setAttribute('data-active-index', index.toString());

      if (animateProgress !== false && this.autoplayEnabled) this.restartProgress();
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.count <= 1 || this.reducedMotion) return;

      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      this.classList.remove('is-autoplay-paused');
      this.restartProgress();
      this.timer = window.setInterval(() => {
        this.goTo(this.current + 1, false);
        this.restartProgress();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
      this.classList.add('is-autoplay-paused');
    }

    restartProgress() {
      this.querySelectorAll('[data-brand-progress]').forEach((bar) => {
        bar.style.animation = 'none';
        bar.style.clipPath = 'inset(0 100% 0 0 round 999px)';
      });

      const bar = this.logos[this.current]?.querySelector('[data-brand-progress]');
      if (!bar || !this.autoplayEnabled || this.classList.contains('is-autoplay-paused')) return;

      void bar.offsetWidth;
      bar.style.animation = '';
      bar.style.clipPath = '';
    }

    initCatalogNav() {
      if (this.catalogNavBound) return;
      this.catalogNavBound = true;

      this.addEventListener('click', (event) => {
        const prev = event.target.closest('[data-brand-prev]');
        const next = event.target.closest('[data-brand-next]');
        if (!prev && !next) return;

        const button = prev || next;
        const slider = document.getElementById(button.getAttribute('aria-controls'));
        if (!slider || button.disabled) return;

        slider.dispatchEvent(
          new CustomEvent(prev ? 'slider:previous' : 'slider:next', {
            bubbles: true,
            cancelable: true,
          })
        );
      });

      this.querySelectorAll('slider-element').forEach((slider) => {
        const catalog = slider.closest('.brand-showcase__catalog');
        if (!catalog) return;

        const prevBtn = catalog.querySelector('[data-brand-prev]');
        const nextBtn = catalog.querySelector('[data-brand-next]');
        if (!prevBtn && !nextBtn) return;

        slider.addEventListener('slider:previousStatus', (event) => {
          if (prevBtn) this.applyNavStatus(prevBtn, event.detail.status);
        });

        slider.addEventListener('slider:nextStatus', (event) => {
          if (nextBtn) this.applyNavStatus(nextBtn, event.detail.status);
        });
      });
    }

    applyNavStatus(button, status) {
      button.hidden = false;
      button.disabled = status === 'disabled' || status === 'hidden';
    }
  }

  customElements.define('brand-hub', BrandHub);
}
